/** The references object of all modules needed for components initialization */
var references = {
    'blog' : require('_core_ext/pages/blog'),
};

module.exports = {
    'references' : references
};
